import React, { useState } from 'react';
import ButtonRow from '../../Elements/ButtonRow';
import ButtonColorsEnum from '../../Enums/ButtonColorsEnum';
import ShownPanelsEnum from '../../Enums/ShownPanelsEnum';
import EndOfMonthItem from '../../Domain/EndOfMonthItem';
import TabOfDataTable from '../../Elements/DataTable/TabOfDataTable';
import EndOfMonthSearchParams from './EndOfMonthSearchParams';
import ErrorMessage from '../../Elements/ErrorMessage';
import GeneralEditWizzardBase from '../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../Enums/CrudTypesEnum';
import EditEndOfMonthWindowDescription from './EditEndOfMonthWindowDescription';
import EndOfMonthService from '../../Services/EndOfMonthService';

const EndOfMonthAdmin = () =>
{
  const [ searchItem, setSearchItem ] = useState({});
  const [ shownPanel, setShownPanel ] = useState();
  const [ selectedItem, setSelectedItem ] = useState(null);

  const handleGetNewEoMDates = () =>
  {
    ErrorMessage.SetApprove('Are you sure you want to get new End of Month suggestions?', () =>
      getEndOfMonthSuggestions()
    );
  };

  const toggleApproval = (selectedItem) =>
  {
    const messageText = selectedItem.ApprovedOnUtc
      ? 'You are about to remove approval from this End of Month. Are you sure you want to proceed?'
      : 'You are about to approve this End of Month. Are you sure you want to proceed?';

    ErrorMessage.SetApprove(messageText, () =>
      EndOfMonthService.ToggleEOMApproval(selectedItem)
        .then(() =>
        {
          ErrorMessage.SetSuccess('The End of Month approval status has been updated.');
          setSearchItem({ ...searchItem });
        })
        .catch((error) =>
        {
          ErrorMessage.SetError('EOMA66', error);
        })
    );
  };
  EndOfMonthItem.toggleApproval = toggleApproval;

  const getEndOfMonthSuggestions = () =>
  {
    EndOfMonthService.GetEndOfMonthDates();
    ErrorMessage.SetSuccessWithWait(
      'End of Month suggestions have been requested. Please check back in a few seconds.'
    );
  };

  const clickOnEdit = (selectedId, selectedItem) =>
  {
    setSearchItem({ ...searchItem });
    setSelectedItem({ ...selectedItem });
    setShownPanel(ShownPanelsEnum.EditItem);
  };
  EndOfMonthItem.editFunction = clickOnEdit;

  const panelOnClose = () =>
  {
    setShownPanel(ShownPanelsEnum.None);
    refresh();
  };

  const refresh = () =>
  {
    setSearchItem({ ...searchItem });
  };

  const startSearch = (newSearchItem) =>
  {
    setSearchItem({ ...newSearchItem });
  };

  const getEditedItem = () =>
  {
    return { ...selectedItem };
  };

  const renderPanels = () =>
  {
    return (
      <div>
        {shownPanel === ShownPanelsEnum.EditItem && (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={getEditedItem()}
            clickOnCancel={panelOnClose}
            clickOnSave={panelOnClose}
            windowDescription={EditEndOfMonthWindowDescription}
            errorCode={'NPA127'}
          />
        )}
      </div>
    );
  };

  const renderButtonsAndPanels = () => (
    <>
      <ButtonRow
        labels={[ 'Suggest EOM' ]}
        colors={[ ButtonColorsEnum.Primary ]}
        keys={[ ShownPanelsEnum.AddNewItem ]}
        icons={[ 'fa-solid fa-chart-line' ]}
        roleKeys={[ 'eom_setup' ]}
        value={shownPanel}
        onClick={handleGetNewEoMDates}
      />
      {renderPanels()}
    </>
  );

  return (
    <div className='contentwrapper'>
      <TabOfDataTable
        type={EndOfMonthItem}
        popupEnabled={true}
        serviceFunction={EndOfMonthService.GetAllItemsBySearching}
        convertDBItemsFunction={EndOfMonthService.ConvertEndOfMonthItems}
        searchItem={searchItem}
        errorCode='EOMA65'
        showSearchStrip={true}
        searchParamsType={EndOfMonthSearchParams}
        orderBy='RevenuePeriod'
        orderDirection='desc'
        clickOnStartSearch={startSearch}
        singleSearchLine={true}
      />
      {renderButtonsAndPanels()}
    </div>
  );
};

export default EndOfMonthAdmin;
